


























































































































import { Component, Vue } from "vue-property-decorator";
import boxDownloadModal from "@/components/boxDownloadModal/index.vue";
import footerCom from "../components/footer/index.vue";
import { tableColumn } from "../listConfig";
import { returnLabel } from "../methods";
import { tagList } from "@/req/homes";
import { gameOpenList } from "@/req/gameJava";
import moment from "moment";
@Component({
  components: { footerCom, boxDownloadModal },
})
export default class Home extends Vue {
  public typeList: any = [];
  public typeIndex = -1;
  public featureList: any = [];
  public featureIndex = -1;
  public columns = tableColumn;
  public data: any = [];
  public page = 1;
  public total = 0;
  public loading = false;
  public isDownload = false;

  public mounted() {
    const arr1: any = localStorage.getItem("GAME_VERSION_LIST");
    const arr2: any = localStorage.getItem("GAME_FEATURE_LIST");
    this.typeList = JSON.parse(arr1);
    this.featureList = JSON.parse(arr2);
    this.getVersionList();
    this.getList();
    (this.$refs.scrollBoxlx as any).addEventListener("scroll", this.add);
  }

  // 获取类型与特色
  public async getVersionList() {
    const res = await tagList({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      this.typeList = res.data.versionList;
      this.featureList = res.data.tagList;
      localStorage.setItem(
        "GAME_VERSION_LIST",
        JSON.stringify(res.data.versionList)
      );
      localStorage.setItem(
        "GAME_FEATURE_LIST",
        JSON.stringify(res.data.tagList)
      );
    }
  }

  public async getList() {
    this.loading = true;
    const res = await gameOpenList({
      versionid: this.typeIndex == -1 ? "" : this.typeList[this.typeIndex].id,
      tag:
        this.featureIndex == -1
          ? ""
          : this.featureList[this.featureIndex].tag_id,
      page: this.page,
      size: 100,
    });
    if (res.code == 200) {
      this.data = [...this.data, ...res.data.game_info.data];
      this.total = res.data.game_info.total;
    }
    this.loading = false;
  }

  public add() {
    const scrollBox: any = this.$refs.scrollBoxlx;
    const a = Math.floor(scrollBox.scrollTop); // 部分edge浏览器是小数，导致滚动失效
    const b = scrollBox.clientHeight;
    const c = scrollBox.scrollHeight;
    if (c - a - b < 1500) {
      if (this.total > this.data.length && !this.loading) {
        this.page = this.page + 1;
        this.getList();
      }
    }
  }

  public typeChange(index) {
    this.typeIndex = index;
    this.page = 1;
    this.data = [];
    this.getList();
  }
  public featureChange(index) {
    this.featureIndex = index;
    this.page = 1;
    this.data = [];
    this.getList();
  }

  public downFile() {
    if (this.isDownload) {
      this.$Message.info("正在下载中, 请勿走开哦");
      return;
    }
    this.isDownload = true;
    const $boxDownloadModal: any = this.$refs.boxDownloadModal;
    $boxDownloadModal.show();
    const filename = "996boxV340SetupSigned@6089.exe";
    const url =
      "https://static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6089.exe";
      // "https://static.dhsf.996box.com/box/channel_app/404s_liehuofengshen_game1697097629.exe";
    const x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = "blob";
    x.onload = () => {
      $boxDownloadModal.close();
      this.isDownload = false;
      const hrefUrl = window.URL.createObjectURL(x.response);
      const a = document.createElement("a");
      a.href = hrefUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    x.send();
  }

  public formatDate(date) {
    return `${moment(date).month() + 1}月${moment(date).date()}日`;
  }

  public formatLabel(list, version, featrue) {
    return returnLabel(list, version, featrue);
  }
}
